import { appId } from './app-id';

export const sendIntercomMessage = (message?: string) => {
  if (!appId) return;
  window.Intercom('showNewMessage', message);
};
